import api from './api-caller';

export default {
  getDataProducts: () => {
    const endpoint = '/exchange/'
    return api(endpoint, 'GET')
  }
}
